module.exports = __webpack_public_path__ + "img/why_01.44832ee1.png";